export class AppGlobalState {
    showAdvancedOptions: boolean = false;
    forceUpdateApp?: () => void;
}
